export default "__VITE_ASSET__oKF0hGUR__"